module.exports = __webpack_public_path__ + "img/banco-cover.cd67fcad.png";